module["exports"] = [
  "SPA",
  "e figli",
  "Group",
  "s.r.l."
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/it/company/suffix.js
// module id = 1280
// module chunks = 0